import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-bg"
        data-testid="auth-loading"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-dim">
          ✦ checking session
        </p>
      </div>
    );
  }
  // Route unauthenticated users to / where the AuthLock greets them.
  if (!user) return <Navigate to="/" replace />;
  return children;
};
